import styled from "styled-components";

const Container = styled.div``;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: min(4.69vw, 67px) min(9.45vw, 98px);
  align-items: center;
  background-color: #eaf4fb;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  align-items: center;
  flex-direction: column;
  h4 {
    font-size: min(4.2vw, 60px);
    line-height: min(4.2vw, 60px);

    color: #000;
    letter-spacing: -0.66px;
    font-family: "robotoblack";
    margin-bottom: min(1.26vw, 18px);
    text-align: center;
    max-width: min(64.26vw, 918px);
  }
  h5 {
    font-size: min(1.4vw, 20px);
    line-height: min(1.82vw, 26px);
    letter-spacing: -0.66px;
    font-family: "robotobold";
    margin-bottom: min(1.26vw, 18px);
    color: #095587;
    text-align: center;
    max-width: min(1036px, 72vw);
  }
  .roll-over {
    position: relative;
    span {
      color: #095587;
      font-size: 16px;
      position: relative;
      z-index: 1;
      background: red;
      padding: 0 10px;
      background-color: #eaf4fb;
      font-style: italic;
    }
    ::after {
      content: "";
      display: block;
      width: calc(100% + 30px);
      height: 1px;
      background-color: #000;
      left: -14px;
      position: absolute;
      bottom: 10px;
      right: 0;
      margin: 0 auto;
      z-index: 0;
    }
  }
  button {
    width: min(11.13vw, 159px);
    height: min(2.73vw, 39px);
    font-size: min(1.19vw, 17px);
    border-radius: min(0.42vw, 6px);
    background-color: #095587;
    font-family: "robotoregular";
    color: #fff;
    margin: min(3.99vw, 57px) auto 0;
    border: none;
  }
  @media (max-width: 767px) {
    padding: min(5.11vw, 73px);
    h4 {
      line-height: 4vw;
      margin-bottom: 2.42vw;
    }
    h5 {
      font-size: 2.84vw;
      line-height: 3.5vw;
      margin-bottom: 2.42vw;
      max-width: 100%;
    }
    img {
      width: 100%;
    }
    button {
      width: 31.7vw;
      height: 7.74vw;
      font-size: 3.38vw;
      border-radius: 6px;
    }
  }
`;
const ToolsWrapper = styled.div`
  /* display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: min(6.37vw, 91px); */
  width: 100%;
  margin-top: min(3.99vw, 57px);
`;
const ToolBox = styled.div`
  .box-row {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .first-row {
    padding-bottom: min(2.778vw, 40px);
    position: relative;
    gap: min(2.222vw, 32px);
    /* .first-row-svg {
      width: min(59.375vw, 855px);
      height: min(12.083vw, 174px);
      z-index: 1;
    } */
    > div {
      display: flex;
      align-items: center;
      gap: min(9.306vw, 134px);
      > span {
        position: relative;
        background: #eaf4fb;
        z-index: 1;
        padding: 0 min(0.694vw, 10px);
        &:first-child,
        &:last-child {
          padding: 0;
        }
      }
      .pallet-buyer {
        width: min(6.944vw, 100px);
        height: min(6.944vw, 100px);
      }
      .pallet-trader-screen {
        width: min(13.194vw, 190px);
        height: min(12.083vw, 174px);
      }
      .pallet-seller {
        width: min(6.944vw, 100px);
        height: min(6.944vw, 100px);
      }
    }
    > span {
      font-size: min(1.389vw, 20px);
      color: #095587;
      width: min-content;
      text-align: center;
      font-family: "robotobold";
    }
    .center-border {
      position: absolute;
      width: 36%;
      height: 5px;
      border-top: min(0.208vw, 3px) dotted #0582bb;
    }
    .bottom-border {
      position: absolute;
      width: 50%;
      left: 0;
      right: auto;
      height: min(2.639vw, 44px);
      border-right: min(0.208vw, 3px) dotted #0582bb;
      bottom: min(0.139vw, 2px);
      z-index: 0;
    }
  }
  .sec-row {
    padding-top: min(3.472vw, 50px);
    justify-content: space-around;
    gap: min(0.347vw, 5px);
    align-items: flex-start;
    position: relative;
    .top-border {
      position: absolute;
      top: 0;
      left: 0;
      right: auto;
      border: min(0.208vw, 3px) dotted #0582bb;
      border-right: 0;
      width: 50%;
      height: min(7.847vw, 113px);
      z-index: 0;
      :hover {
        transform: scale(1);
      }
    }
    .bottom-border {
      position: absolute;
      left: auto;
      right: 0;
      border: min(0.208vw, 3px) dotted #0582bb;
      border-left: 0;
      width: 50%;
      height: 207px;
      top: min(7.639vw, 110px);
      z-index: 0;
      :hover {
        transform: scale(1);
      }
    }
    :hover {
      > div svg:last-child {
        path {
          opacity: 0.5;
        }
      }
    }

    > div {
      transition: all 0.25s ease-in-out;
      transform: scale(1);
      width: min(9.583vw, 138px);
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      position: relative;
      z-index: 1;

      :nth-child(3) {
        svg {
          width: min(7.639vw, 110px);
          height: min(5vw, 72px);
        }
      }
      :nth-child(4) {
        svg {
          width: min(8.333vw, 120px);
          height: min(8.333vw, 120px);
        }
      }
      :nth-child(5) {
        svg {
          width: min(7.847vw, 113px);
          height: min(4.514vw, 65px);
        }
      }
      :nth-child(6) {
        svg {
          width: min(6.944vw, 100px);
          height: min(6.944vw, 100px);
        }
      }
      :nth-child(7) {
        svg {
          width: min(4.583vw, 66px);
          height: min(5.903vw, 85px);
        }
      }
      .icon-wrapper {
        padding: 0 min(0.729vw, 10.5px);
        height: min(9.028vw, 130px);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: min(0.931vw, 13.4px);
        border: min(0.139vw, 2px) solid transparent;
        background-color: transparent;
      }
      > p {
        visibility: hidden;
        text-transform: capitalize;
        margin-bottom: 0;
        background-color: #ffffff;
      }

      svg {
        :last-child {
          display: block;
          background-color: #eaf4fb;
          padding: min(0.347vw, 5px);
          path {
            fill: black;
          }
        }
        :first-child {
          display: none;
        }
      }
      .search-icon {
        display: none;
        height: min(6.597vw, 95px);
        width: min(7.639vw, 110px);
      }
      .note-icon {
        display: none;
        height: min(4.028vw, 58px);
        width: min(7.639vw, 110px);
      }
      &:hover {
        transform: scale(1.67);
        .icon-wrapper {
          border-color: #005586;
          background-color: #ffffff;
        }
        svg {
          :last-child {
            display: none;
          }
          :first-child {
            display: block;
          }
        }
        > p {
          border: min(0.139vw, 2px) solid #005586;
          color: #005586;
          font-size: min(0.833vw, 12px);
          border-radius: min(0.931vw, 13.4px);
          max-width: min(14.375vw, 207px);
          padding: min(0.417vw, 6px) min(1.25vw, 18px);
          text-align: center;
          line-height: normal;
          visibility: unset;
        }
      }
    }
  }
  .third-row {
    z-index: 0;
    svg {
      width: min(14.653vw, 211px);
      height: min(10.417vw, 150px);
    }
    > div {
      position: relative;
      z-index: 1;
      background-color: #eaf4fb;
      padding: 0 10px;
    }
  }
`;

export { Container, Wrapper, ToolsWrapper, ToolBox };
